import { makeStateKey } from '@angular/core';

export interface TenantLookupData {
  tenant_uuid: string;
  name?: string;
  fqdn?: string;
  accent_color?: string | null;
  setting?: {
    logo_url?: string;
    banner_url?: string;
    favicon_url?: string;
  };
  settings?: {
    sokrates?: {
      logo_url?: string;
      banner_url?: string;
      favicon_url?: string;
    };
  };
}

export const TENANT_TRANSFER_STATE_KEY = makeStateKey<TenantLookupData | null>('tenant-lookup');
